var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',_vm._b({attrs:{"loading":_vm.isLoading,"prepend-icon":"las la-file"},on:{"change":_vm.onSelect}},'v-file-input',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }